import AppRouter from './router';
import ErrorBoundary from './components/ErrorBoundary';
import { ThemeProvider } from './layouts/ThemeProvider';
import { Toaster } from '@/components/ui/sonner';
import { ConfirmDialog } from '@/components/ConfirmDialog';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { queryClient } from '@/lib/queryClient';
import { APP_CONFIG, FEATURE_CONFIG } from './config/env';

/**
 * 应用根组件
 * 集成路由系统、错误边界、主题提供者
 */
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider storageKey="ui-theme">
        <ErrorBoundary>
          <div className="App h-screen">
            <AppRouter />
            {/* Toast 通知系统 */}
            <Toaster position="top-center" />
            {/* 全局确认弹窗 */}
            <ConfirmDialog />
          </div>
        </ErrorBoundary>
      </ThemeProvider>
      {APP_CONFIG.isDev && FEATURE_CONFIG.showReactQueryDevTools && (
        <ReactQueryDevtools initialIsOpen={false} />
      )}
    </QueryClientProvider>
  );
}

export default App;
